/**
 * @name API Config
 * @memberof module:common/config
 * @type {Config}
 * @return {Object} Configurations of API
 */

const BASE_HOST = process.env.REACT_APP_API_ENDPOINT;
export const BASE_DEV_HOST = `${BASE_HOST}`;

export const ECS_HOST = process.env.REACT_APP_ECS_API_ENDPOINT;
export const LARGE_REQUESTS_ENDPOINT = ECS_HOST || BASE_DEV_HOST;
export const OK_200 = '200';
export const OK_201 = '201';
export const ERROR_400 = '400'; // Bad Request
export const ERROR_401 = '401'; // Unauthorized
export const ERROR_403 = '403'; // Forbidden
export const ERROR_404 = '404'; // Not Found
export const ERROR_408 = '408'; // Request Timeout
export const ERROR_409 = '409'; // Conflict
export const ERROR_429 = '429'; // Too Many Requests
export const ERROR_500 = '500'; // Internal Server Error
export const ERROR_504 = '504'; // Gateway Timeout

export default BASE_DEV_HOST;
